import config from "../config";
import useFeatureEnabled from "../hooks/useFeatureEnabled";

const APP_ENVS = {
  DEVELOPMENT: "Development",
  STAGING: "Staging",
  INTERNAL: "Internal",
  PRODUCTION: "Production",
};

export const getMarvinUIEnabled = (auth) => {
  const { features } = auth;
  const env = config.environment;
  if ([APP_ENVS.PRODUCTION, APP_ENVS.INTERNAL].includes(env)) {
    return features && features.Marvin;
  }
  return true;
};

export const useMarvinFeatureEnabled = () => {
  const { marvinEnabled } = useFeatureEnabled();
  const env = config.environment;
  if ([APP_ENVS.PRODUCTION, APP_ENVS.INTERNAL].includes(env)) {
    return marvinEnabled;
  }
  return true;
};
